
import {
  INIT_PAGE_INFO,
  REQUEST_PAGE_START,
  REQUEST_PAGE_SUCCESS,
  REQUEST_PAGE_FAIL,

  PATCH_PAGE_START,
  PATCH_PAGE_SUCCESS,
  PATCH_PAGE_FAIL,

  POST_PAGE_START,
  POST_PAGE_SUCCESS,
  POST_PAGE_FAIL,

  PUT_PAGE_START,
  PUT_PAGE_SUCCESS,
  PUT_PAGE_FAIL,

  DELETE_PAGE_START,
  DELETE_PAGE_SUCCESS,
  DELETE_PAGE_FAIL,

  MULTIPLE_DELETE_PAGE_START,
  MULTIPLE_DELETE_PAGE_SUCCESS,
  MULTIPLE_DELETE_PAGE_FAIL,

  REQUEST_DETAIL_PAGE_START,
  REQUEST_DETAIL_PAGE_SUCCESS,
  REQUEST_DETAIL_PAGE_FAIL,

  POST_SECTION_START,
  POST_SECTION_SUCCESS,
  POST_SECTION_FAIL,

  POST_SECTION_ITEM_START,
  POST_SECTION_ITEM_SUCCESS,
  POST_SECTION_ITEM_FAIL,

  PUT_SECTION_ITEM_START,
  PUT_SECTION_ITEM_SUCCESS,
  PUT_SECTION_ITEM_FAIL,

  DELETE_SECTION_ITEM_START,
  DELETE_SECTION_ITEM_SUCCESS,
  DELETE_SECTION_ITEM_FAIL,

  PATCH_SECTION_START,
  PATCH_SECTION_SUCCESS,
  PATCH_SECTION_FAIL,

  PUT_SECTION_START,
  PUT_SECTION_SUCCESS,
  PUT_SECTION_FAIL,

  DELETE_SECTION_START,
  DELETE_SECTION_SUCCESS,
  DELETE_SECTION_FAIL,

  REQUEST_PRODUCT_GROUP_START,
  REQUEST_PRODUCT_GROUP_SUCCESS,
  REQUEST_PRODUCT_GROUP_FAIL,

  POST_PRODUCT_GROUP_START,
  POST_PRODUCT_GROUP_SUCCESS,
  POST_PRODUCT_GROUP_FAIL,

  PUT_PRODUCT_GROUP_START,
  PUT_PRODUCT_GROUP_SUCCESS,
  PUT_PRODUCT_GROUP_FAIL,

  DELETE_PRODUCT_GROUP_START,
  DELETE_PRODUCT_GROUP_SUCCESS,
  DELETE_PRODUCT_GROUP_FAIL,

  MULTIPLE_DELETE_PRODUCT_GROUP_START,
  MULTIPLE_DELETE_PRODUCT_GROUP_SUCCESS,
  MULTIPLE_DELETE_PRODUCT_GROUP_FAIL,

  REQUEST_DETAIL_PRODUCT_GROUP_START,
  REQUEST_DETAIL_PRODUCT_GROUP_SUCCESS,
  REQUEST_DETAIL_PRODUCT_GROUP_FAIL,
  
  DELETE_ITEM_START,
  DELETE_ITEM_SUCCESS,
  DELETE_ITEM_FAIL,

} from '../actions/home-management';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case PATCH_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case PATCH_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case PATCH_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case POST_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case POST_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case POST_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case PUT_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case PUT_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case PUT_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case DELETE_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case DELETE_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case DELETE_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case MULTIPLE_DELETE_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case MULTIPLE_DELETE_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case MULTIPLE_DELETE_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case REQUEST_DETAIL_PAGE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_DETAIL_PAGE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_DETAIL_PAGE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case POST_SECTION_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case POST_SECTION_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case POST_SECTION_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case POST_SECTION_ITEM_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case POST_SECTION_ITEM_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case POST_SECTION_ITEM_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case PUT_SECTION_ITEM_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case PUT_SECTION_ITEM_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case PUT_SECTION_ITEM_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case DELETE_SECTION_ITEM_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case DELETE_SECTION_ITEM_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case DELETE_SECTION_ITEM_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case PATCH_SECTION_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case PATCH_SECTION_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case PATCH_SECTION_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case PUT_SECTION_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case PUT_SECTION_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case PUT_SECTION_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case DELETE_SECTION_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case DELETE_SECTION_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case DELETE_SECTION_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case REQUEST_PRODUCT_GROUP_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_PRODUCT_GROUP_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_PRODUCT_GROUP_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case POST_PRODUCT_GROUP_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case POST_PRODUCT_GROUP_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case POST_PRODUCT_GROUP_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case PUT_PRODUCT_GROUP_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case PUT_PRODUCT_GROUP_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case PUT_PRODUCT_GROUP_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================


    case DELETE_PRODUCT_GROUP_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case DELETE_PRODUCT_GROUP_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case DELETE_PRODUCT_GROUP_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case MULTIPLE_DELETE_PRODUCT_GROUP_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case MULTIPLE_DELETE_PRODUCT_GROUP_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case MULTIPLE_DELETE_PRODUCT_GROUP_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case REQUEST_DETAIL_PRODUCT_GROUP_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_DETAIL_PRODUCT_GROUP_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_DETAIL_PRODUCT_GROUP_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case DELETE_ITEM_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case DELETE_ITEM_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case DELETE_ITEM_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    //===============================================================================

    case INIT_PAGE_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
